module.exports = __webpack_public_path__ + "img/arrow-up-s.0cf9dd54.svg";